import CustomReportChannel from '@/Enums/ReportBuilder/ReportChannel.enum';
import type { ICustomReportTemplateListItem } from '@/Interfaces/ReportBuilder/Template.interface';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import type {
  CustomReportTemplateDeleteFunction,
  CustomReportTemplateShareFunction,
} from '@/types/ReportBuilder/GridFunction.types';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import ActionChip from './ActionChip';

const CHANNEL_LABEL: Record<CustomReportChannel, string> = {
  // flank#4914 — renamed from "Beeswax" to the client-facing platform name.
  [CustomReportChannel.Beeswax]: 'Buyer Cloud',
  [CustomReportChannel.Youtube]: 'YouTube',
  [CustomReportChannel.Omniplatform]: 'Omniplatform',
};

interface IGetColumnsArgs {
  onShareTemplate: CustomReportTemplateShareFunction;
  onDeleteTemplate: CustomReportTemplateDeleteFunction;
}

export const getColumns = ({ onShareTemplate, onDeleteTemplate }: IGetColumnsArgs): GridColDef[] => [
  {
    field: 'name',
    flex: 2,
    headerName: 'Template Name',
  },
  {
    field: 'channel',
    flex: 1,
    headerName: 'Channel',
    valueFormatter: (value: CustomReportChannel) => CHANNEL_LABEL[value] ?? value,
  },
  {
    field: 'createdAt',
    flex: 1,
    headerName: 'Created Date',
    sortable: false,
    valueFormatter: (value: string) => dateToShortFormat(value),
  },
  {
    field: 'owner',
    flex: 2,
    headerName: 'Owner',
    sortable: false,
    valueGetter: (_: unknown, row: ICustomReportTemplateListItem) => row.owner?.fullName ?? row.owner?.email ?? '',
  },
  {
    field: 'id',
    flex: 1.5,
    headerName: 'Action',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<ICustomReportTemplateListItem>) => (
      <ActionChip {...params} onShareTemplate={onShareTemplate} onDeleteTemplate={onDeleteTemplate} />
    ),
  },
];
